import React from 'react';
import { Route, IndexRoute } from 'react-router';

import ColumnistsLayout from 'modules/News/containers/ColumnistsLayout';
import CustomBasketLayout from 'modules/News/containers/CustomBasketLayout';

import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';

import SectionPlainTitle from 'modules/Common/components/SectionPlainTitle';
import MoreNews from 'modules/News/containers/MoreNews';
import CustomBasketNews from 'modules/News/containers/CustomBasketNews';
import MostReadAll from 'modules/Common/containers/MostReadAll';

import SectionLink from 'modules/Common/components/SectionLink';
import RacingTips from 'modules/Common/containers/RacingTips';
import FootballTips from 'modules/Common/containers/FootballTips';
import HorseRacingNextRaceOff from 'modules/Common/containers/HorseRacingNextRaceOff';

const ColumnistsComponents = {
  MostReadAll,
  SectionPlainTitle,
  MoreNews,
  GooglePublisherTag,
  AdvertWrapper,
  SectionLink,
  RacingTips,
  HorseRacingNextRaceOff,
  FootballTips
}

const CustomBasketComponents = {
  MostReadAll,
  CustomBasketNews,
  GooglePublisherTag,
  AdvertWrapper,
  SectionLink,
  RacingTips,
  HorseRacingNextRaceOff,
  FootballTips
}

const newsRoutes = (
  <Route>
    <Route path="columnists" component={ColumnistsLayout}> {/* layout manager */}
      <IndexRoute components={ColumnistsComponents}/> {/* layout */}
    </Route>
    <Route path="news/:basketName/:basketId" component={CustomBasketLayout}> {/* layout manager */}
      <IndexRoute components={CustomBasketComponents}/> {/* layout */}
    </Route>
  </Route>
)

export default newsRoutes;




// WEBPACK FOOTER //
// ./modules/News/routes.js